module.exports = __webpack_public_path__ + "img/set-conference-day3-infographic.61c6c7bd.png";